import { MotionProvider } from "./design/MotionProvider";
import type { PortalGateway } from "./features/sessions/api";
import { M1Shell } from "./features/sessions/M1Shell";

export const App = ({
  gateway = null,
  runId = null,
}: {
  gateway?: PortalGateway | null;
  runId?: string | null;
}) => (
  <MotionProvider>
    <M1Shell gateway={gateway} runId={runId} />
  </MotionProvider>
);
